export const CONTEST_TYPES = {
  single: 'single',
  group: 'group',
};
